// Open every `mailto:` link in Gmail's web compose (new tab) instead of handing
// off to the desktop mail client (Apple Mail / Outlook desktop), which is what
// staff on Google Workspace almost always want. One delegated click listener
// covers every mail link on the site — including ones rendered later — so no
// individual `mailto:` href has to change.

/** Convert a `mailto:` href into a Gmail web-compose URL, preserving
 *  to / cc / bcc / subject / body. */
export function mailtoToGmail(href) {
  const raw = String(href || '').replace(/^mailto:/i, '');
  const qIdx = raw.indexOf('?');
  const addrPart = qIdx === -1 ? raw : raw.slice(0, qIdx);
  const queryPart = qIdx === -1 ? '' : raw.slice(qIdx + 1);
  let to = addrPart;
  try { to = decodeURIComponent(addrPart); } catch { /* leave as-is */ }
  const params = new URLSearchParams(queryPart);
  const gmail = new URL('https://mail.google.com/mail/');
  gmail.searchParams.set('view', 'cm'); // compose
  gmail.searchParams.set('fs', '1');     // full-screen compose window
  if (to.trim()) gmail.searchParams.set('to', to.trim());
  const map = { subject: 'su', body: 'body', cc: 'cc', bcc: 'bcc' };
  for (const [mk, gk] of Object.entries(map)) {
    const v = params.get(mk);
    if (v) gmail.searchParams.set(gk, v);
  }
  return gmail.toString();
}

/** Install a one-time, app-wide click interceptor for `mailto:` links. */
export function installGmailMailtoHandler() {
  if (typeof document === 'undefined' || window.__gmailMailtoInstalled) return;
  window.__gmailMailtoInstalled = true;
  document.addEventListener('click', (e) => {
    const a = e.target?.closest?.('a[href^="mailto:"], a[href^="MAILTO:"]');
    if (!a) return;
    e.preventDefault();
    e.stopPropagation(); // don't also trigger an enclosing row/card click
    const url = mailtoToGmail(a.getAttribute('href'));
    window.open(url, '_blank', 'noopener');
  });
}

export default installGmailMailtoHandler;
